<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import POList from "@/components/widgets/PoList";
import PrintOptions from "@/components/modals/print-options.vue";
import Contract from "@/components/modals/contract-history.vue";
import PoSearch from "@/components/modals/purchase-order-search.vue";
import DeliveryModal from "@/components/modals/delivery-modal.vue";
import PoItemUpdate from "@/components/modals/PoItemUpdate.vue";
import AttachmentModal from "@/components/modals/attachment-modal.vue";
import TransferCampusModal from "@/components/modals/transfer-campus-modal.vue";

export default {
    page: {
        title: "Incoming Deliveries"
    },
    components: {
        Layout,
        PageHeader,
        POList,
        PrintOptions,
        Contract,
        PoSearch,
        DeliveryModal,
        PoItemUpdate,
        AttachmentModal,
        TransferCampusModal
    },
    data() {
        return {
            title: "Incoming Deliveries",
            items: [
                {
                    text: "Dashboards",
                    href: "/"
                },
                {
                    text: "Incoming Deliveries",
                    active: true
                }
            ],
            viewOnly: false,
            statusOptions: [
                {ind: 0, text: "Ongoing"},
                {ind: 1, text: "To Expire"},
                {ind: 2, text: "Expired"},
                {ind: 3, text: "Pending Contracts"},
                {ind: 4, text: "Approved Contracts"},
                {ind: 7, text: "All"},
                {ind: 8, text: "Completed"}
            ],
            pendingData: [],
            completedData: [],
            toExpireData: [],
            expiredData: [],
            loading: false,
            selectedTab: 0,
            mouseOverSearch: false,
            modalTitle: "",
            cycles: [],
            pendingExtensionsData: [],
            approvedExtensionsData: [],
        };
    },
    created() {
        this.changeData(this.$store.state.data.selectedCampus.id, this.$store.state.data.cycle);
        this.getCycleOptions();
        if (this.$store.state.decrypt.isAdmin()) {
            return this.viewOnly = false;
        }
        let accessList = this.$store.state.decrypt.userAccessList();
        let access = accessList.find(
            (x) =>
            x.Access.toLowerCase() === "manage incoming delivery" &&
            x.Type.toLowerCase() === "inspection"
        );
        if (access) {
            this.viewOnly = false;
        } else {
            this.viewOnly = true;
        }
    },
    methods: {
        getCycleOptions() {
            var cycles = [{ text: "", value: 0 }];
            this.$store.dispatch("cycle/GetAllCycle").then((res) => {
                res.data.forEach((item) => {
                    cycles.push({ value: item.year, text: item.year });
                });
                this.cycles = cycles;
            });
        },
        async changeData(campusId, cycle) {
            this.loading = true;
            this.pendingData = [];
            this.completedData = [];
            this.toExpireData = [];
            this.expiredData = [];
            this.pendingExtensionsData = [];
            this.approvedExtensionsData = [];
            if (this.selectedTab === 8) {
                await this.getCompleted(campusId, cycle);
            } else {
                await this.getPending(campusId, cycle);
            }
            this.loading = false;
        },
        async getPending(campusId, cycle) {
            if(this.pendingData.length > 0) return;
            await this.$store
                .dispatch("inspectioncontract/GetInspectionContractPending", { cycle, campusId })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.forEach((x) => {
                        x.loading = false;
                        x.visible = false;
                        x.toggleAll = false;
                        x.allSupplierOffer = true;
                        x.allRequestedItem = false;
                        x.rfqSupplierOffers = [];
                        x.addDocu = false;
                        x.attachmentLoading = false;
                        x.poFiles = [];
                        x.viewFile = false;
                    });
                    this.pendingData = res.data.sort(function (a, b) {
                        return b.expectedDelivery.localeCompare(a.expectedDelivery);
                    });
                }).catch((err) => {
                    this.showToast("Something went wrong - Getting incoming deliveries!", "error");
                });
        },
        async getCompleted(campusId, cycle) {
            if(this.completedData.length > 0) return;
            await this.$store
                .dispatch("inspectioncontract/GetInspectionContractCompleted", { cycle, campusId })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.forEach((x) => {
                        x.loading = false;
                        x.visible = false;
                        x.toggleAll = false;
                        x.allSupplierOffer = true;
                        x.allRequestedItem = false;
                        x.rfqSupplierOffers = [];
                        x.addDocu = false;
                        x.attachmentLoading = false;
                        x.poFiles = [];
                        x.viewFile = false;
                    });
                    this.completedData = res.data.sort(function (a, b) {
                        return b.expectedDelivery.localeCompare(a.expectedDelivery);
                    });
                }).catch((err) => {
                    this.showToast("Something went wrong - Getting incoming deliveries!", "error");
                });
        },
        async getToExpire(campusId, cycle) {
            if(this.toExpireData.length > 0) return;
            await this.$store
                .dispatch("inspectioncontract/GetInspectionContractToExpire", { cycle, campusId })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.forEach((x) => {
                        x.loading = false;
                        x.visible = false;
                        x.toggleAll = false;
                        x.allSupplierOffer = true;
                        x.allRequestedItem = false;
                        x.rfqSupplierOffers = [];
                        x.addDocu = false;
                        x.attachmentLoading = false;
                        x.poFiles = [];
                        x.viewFile = false;
                    });
                    this.toExpireData = res.data.sort(function (a, b) {
                        return b.expectedDelivery.localeCompare(a.expectedDelivery);
                    });
                }).catch((err) => {
                    this.showToast("Something went wrong - Getting incoming deliveries!", "error");
                });
        },
        async getExpired(campusId, cycle) {
            if(this.expiredData.length > 0) return;
            await this.$store
                .dispatch("inspectioncontract/GetInspectionContractExpired", { cycle, campusId })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.forEach((x) => {
                        x.loading = false;
                        x.visible = false;
                        x.toggleAll = false;
                        x.allSupplierOffer = true;
                        x.allRequestedItem = false;
                        x.rfqSupplierOffers = [];
                        x.addDocu = false;
                        x.attachmentLoading = false;
                        x.poFiles = [];
                        x.viewFile = false;
                    });
                    this.expiredData = res.data.sort(function (a, b) {
                        return b.expectedDelivery.localeCompare(a.expectedDelivery);
                    });
                }).catch((err) => {
                    this.showToast("Something went wrong - Getting incoming deliveries!", "error");
                });
        },
        async getPendingExtensions(campusId, cycle) {
            if(this.pendingExtensionsData.length > 0) return;
            await this.$store
                .dispatch("inspectioncontract/GetInspectionContractPending", { campusId, cycle })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.pendingExtensionsData = res.data || [];
                }).catch((err) => {
                    this.showToast("Something went wrong - Getting pending extensions!", "error");
                });
        },
        async getApprovedExtensions(campusId) {
            if(this.approvedExtensionsData.length > 0) return;
            await this.$store
                .dispatch("inspectionextension/GetApprovedDeliveryExtensionByCampus", campusId)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    console.log(res.data);
                    this.approvedExtensionsData = res.data || [];
                }).catch((err) => {
                    this.showToast("Something went wrong - Getting approved extensions!", "error");
                });
        },
        getTabIcon(status) {
            switch (status) {
                case 'Ongoing':
                return 'mdi mdi-clock-outline text-success';
                case 'To Expire':
                return 'mdi mdi-clock-alert-outline text-warning';
                case 'Expired':
                return 'mdi mdi-clock-remove-outline text-danger';
                case 'Pending Contracts':
                return 'mdi mdi-calendar-clock text-info';
                case 'Approved Contracts':
                return 'mdi mdi-check text-warning';
                case 'All':
                return 'mdi mdi-view-grid-outline';
                default:
                return 'mdi mdi-check-circle-outline text-success';
            }
        },
        async getDataByStatus(index){
            this.loading = true;
            if(index == 0){
                await this.getPending(this.$store.state.data.selectedCampus.id, this.$store.state.data.cycle);
            } else if(index == 1){
                await this.getToExpire(this.$store.state.data.selectedCampus.id, this.$store.state.data.cycle);
            } else if(index == 2){
                await this.getExpired(this.$store.state.data.selectedCampus.id, this.$store.state.data.cycle);
            } else if(index == 3){
                await this.getPendingExtensions(this.$store.state.data.selectedCampus.id);
            }else if(index == 4){
                await this.getApprovedExtensions(this.$store.state.data.selectedCampus.id);
            } else if(index == 8) {
                await this.getCompleted(this.$store.state.data.selectedCampus.id, this.$store.state.data.cycle);
            }
            this.loading = false;
        },
        printDP(id) {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Procurement/Deployment",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        getSuspension(row, type) {
            if (!row.extensionsLoaded) {
                this.loadContractExtensions(row);
            }
            this.$refs.contract.getSuspension(row, type);
            this.$bvModal.show("modal-contract");
        },
        loadContractExtensions(item) {
            if (!item.extensionsLoaded) {
                item.extensionsLoaded = true;
                item.extensionsLoading = true;
                this.$store
                    .dispatch("inspectionextension/GetDeliveryExtensionByPo", item.id)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        item.poDeliveryExtensions = res.data || [];
                        item.extensionsLoading = false;
                    })
                    .catch(() => {
                        item.poDeliveryExtensions = [];
                        item.extensionsLoading = false;
                    });
            }
        },
        createIar(props) {
            this.$refs.delRef.setData(props);
            this.poIndex = this.pendingData.indexOf(props);
            this.modalTitle = "Delivery";
            this.$bvModal.show("delivery-modal");
        },
        searchPo() {
            this.$refs.PoSearch.resetData();
            this.$bvModal.show("po-search-modal");
        },
        setIarItems(item, data) {
            if (parseFloat(item.qtyDelivered) > 0) {
                data.iarItems.push({
                    itemName: `${item.toggleRequest ? `${item.requestName}` : ""}${item.toggleRequest && item.toggleOffer ? ", " : " "
                        }${item.toggleOffer ? `${item.offerName}` : ""}`,
                    description: `${item.toggleRequest ? `${item.requestDescription}` : ""
                        }${item.toggleRequest && item.toggleOffer ? ", " : " "}${item.toggleOffer ? `${item.offerDescription}` : ""
                        }`,
                    iarId: item.iarId,
                    rfqSupplierOfferId: item.rfqSupplierOfferId,
                    brand: item.brand,
                    model: item.model,
                    specification: item.specification,
                    color: item.color,
                    dimensionDescription: item.dimensionDescription,
                    materialUsed: item.materialUsed,
                    packageDescription: item.packageDescription,
                    condition: item.condition,
                    unitId: item.unitId,
                    unitName: item.unitName,
                    itemCategoryId: item.itemCategoryId,
                    itemCategoryName: item.itemCategoryName,
                    unitCost: this.getExactAmt(item.unitCost),
                    warrantyStartDate: "0001-01-01T00:00:00",
                    warrantyEndDate: "0001-01-01T00:00:00",
                    notes: item.notes,
                    quantity: item.qtyDelivered,
                    isDelivered: true,
                    locationAreaId: item.locationAreaId,
                    locationAreaName: item.locationAreaName
                });
            }
            if (parseFloat(item.qtyWaived) > 0) {
                data.iarItems.push({
                    itemName: `${item.toggleRequest ? `${item.requestName}` : ""}${item.toggleRequest && item.toggleOffer ? ", " : " "
                        }${item.toggleOffer ? `${item.offerName}` : ""}`,
                    description: `${item.toggleRequest ? `${item.requestDescription}` : ""
                        }${item.toggleRequest && item.toggleOffer ? ", " : " "}${item.toggleOffer ? `${item.offerDescription}` : ""
                        }`,
                    iarId: item.iarId,
                    rfqSupplierOfferId: item.rfqSupplierOfferId,
                    brand: item.brand,
                    model: item.model,
                    specification: item.specification,
                    color: item.color,
                    dimensionDescription: item.dimensionDescription,
                    materialUsed: item.materialUsed,
                    packageDescription: item.packageDescription,
                    condition: item.condition,
                    unitId: item.unitId,
                    unitName: item.unitName,
                    itemCategoryId: item.itemCategoryId,
                    itemCategoryName: item.itemCategoryName,
                    unitCost: this.getExactAmt(item.unitCost),
                    warrantyStartDate: "0001-01-01T00:00:00",
                    warrantyEndDate: "0001-01-01T00:00:00",
                    notes: item.notes,
                    quantity: item.qtyWaived,
                    isDelivered: false
                });
            }
        },
        checkIfWaived(data) {
            var count = 0;
            data.formItems.forEach((item) => {
                if (item.qtyDelivered == 0 && item.qtyWaived > 0) count++;
            });
            if (count < data.formItems.length) return true;
        },
        onCreateIAR(data) {
            this.$swal({
                title: "Select an Action",
                text: "Do you want to send an Email to COA confirming delivery arrival?",
                icon: "question",
                showCancelButton: true,
                showDenyButton: true,
                cancelButtonColor: "#5c636a",
                denyButtonColor: "#34c38f",
                denyButtonText: "Confirm & Email",
                confirmButtonColor: "#349ac3",
                confirmButtonText: "Just Confirm",
                customClass: {
                    actions: "my-actions",
                    denyButton: "order-1",
                    confirmButton: "order-2",
                    cancelButton: "order-3 left-gap"
                },
                allowOutsideClick: false
                }).then((result) => {
                    if (result.isDismissed) return;
                    data.sendEmail = result.isConfirmed ? false : true;
                    data.createAndPost = false;
                    data.iarItems = [];
                    data.formItems.forEach((item) => {
                        this.setIarItems(item, data);
                    });
                    data.dateInspected = "0001-01-01T00:00:00";
                    data.dateOfDelivery = this.getDate(data.dateOfDelivery);
                    if (this.checkIfWaived(data)) {
                        data.acceptanceDate = this.getDate(data.acceptanceDate);
                    } else {
                        data.acceptanceDate = "0001-01-01T00:00:00";
                        data.drNumber = "";
                    }
                    this.$store
                        .dispatch("inspectioniar/CreateInspectionIar", data)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            var poIndex = this.pendingData.findIndex((item) => item.id == data.poId);
                            this.pendingData[poIndex].toggleAll = false;
                            var count = 0;
                            data.iarItems.forEach((x) => {
                            var itemIndex = this.pendingData[poIndex].rfqSupplierOffers.findIndex((item) => item.id == x.rfqSupplierOfferId);
                            this.pendingData[poIndex].rfqSupplierOffers[itemIndex].toggleSelected = false;
                            this.pendingData[poIndex].rfqSupplierOffers[itemIndex].availableItemsForIar = parseFloat(this.pendingData[poIndex].rfqSupplierOffers[itemIndex].availableItemsForIar) - parseFloat(x.quantity);
                            if (this.pendingData[poIndex].rfqSupplierOffers[itemIndex].availableItemsForIar == 0) {
                                count++;
                            }
                            if (this.pendingData[poIndex].rfqSupplierOffers.length == count) {
                                this.pendingData.splice(poIndex, 1);
                            }
                            this.showToast("Successfully confirmed!", "success");
                            this.$bvModal.hide("delivery-modal");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong - setting delivery!", "error");
                        });
                    this.$refs.delRef.submitted = false;
                });
            })
        },
        async viewAttachments(item) {
            this.$refs.attachmentModal.setUploadOpt({
                type: "Purchase Order",
                placement: "lefttop",
                folder: "Property"
            });
            this.$bvModal.show("upload-attachment-modal");
            await this.$refs.attachmentModal.getMultipleData([
                { 
                    id: item.id, 
                    type: 'Purchase Order', 
                },
                {
                    id: item.prId, 
                    type: 'Purchase Request', 
                }
            ], item.id);
        },
        updatePoItem(poData, itemData) {
            this.selectedPo = poData;
            this.$refs.poItemUpdate.resetForm();
            this.$refs.poItemUpdate.getData(itemData);
            this.modalTitle = "Update Item";
            this.$bvModal.show("modal-update-item");
        },
        updateItem(data){
            this.$swal({
                title: "Are you sure?",
                text: "You are about to update this item!",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, update item!",
                allowOutsideClick: false
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("rfqsupplieroffer/UpdateRSO", data)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            this.selectedPo.visible = false;
                            this.$refs[`poListRef-${this.selectedTab}`][0].getRfqItems(this.selectedPo);
                            this.showToast("Successfully updated!", "success");
                            this.$bvModal.hide('modal-update-item');
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                    }
            });
        },
        transferCampus(props) {
            this.$refs.transferCampusModal.resetForm();
            this.selectedPo = props;
            this.modalTitle = `${this.GLOBAL_FROM_SCHOOL ? 'Transfer Campus' : 'Transfer Main Office'}`;
            this.$bvModal.show("modal-transfer-campus");
        },
        onTransfer(data){
            this.$store
                .dispatch("po/MoveToCampus", { id: this.selectedPo.poId, campusId: data.campusId })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let index = this.pendingData.findIndex((x) => x.id === this.selectedPo.id);
                    this.pendingData.splice(index, 1);
                    this.showToast("Successfully transfered!", "success");
                    this.$bvModal.hide('modal-transfer-campus');
                })
                .catch((err) => { this.showToast("Something went wrong!", "error")});
        },
        returnData(index) {
            if(index == 1){
                return this.toExpireData;
            }
            if(index == 2){
                return this.expiredData;
            }
            if(index == 8){
                return this.completedData;
            }
            return this.pendingData;
        },
        selectTab(index, status) {
            // if(status.id == 3){
            //     if(index == 0){

            //     }else if(index == 1){

            //     }else if(index == 2){

            //     }else if(index == 3){
                    
            //     }
            // }else if(status.id == 4){
            //     if(index == 0){

            //     }else if(index == 1){

            //     }else if(index == 2){

            //     }else if(index == 3){
                    
            //     }
            // }
        }
    }
  
}
</script>
<template>
  <Layout @changeCampus="changeData($event.id, $store.state.data.cycle)" @changeCycle="changeData($store.state.data.selectedCampus.id, $event)">
    <PageHeader :title="title" :items="items" />
    <b-tabs 
        pills
        vertical
        nav-class="p-0"
        nav-wrapper-class="col-sm-2"
        content-class="pt-0 px-2 text-muted"
        v-model="selectedTab"
    >
        <b-tab v-for="(status, index) in statusOptions" :key="index" @click="getDataByStatus(status.ind)" :value="index"> 
            <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                    <i :class="getTabIcon(status.text)"></i>
                </span>
                <span class="d-none d-sm-inline-block">{{ status.text }}</span>
            </template>
            <POList 
                :ref="`poListRef-${index}`"
                :viewOnly="viewOnly"
                :loading="loading"
                :tableData="returnData(status.ind)"
                :status="status.text"
                @print-deployment="printDP($event)"
                @get-suspension="getSuspension($event.item, $event.action)"
                @create-iar="createIar($event)"
                @view-attachments="viewAttachments($event)"
                @update-po-item="updatePoItem($event.poData, $event.itemData)"
                @transfer-campus="transferCampus($event)"
                @tab-selected="selectTab($event, status)"
            />
        </b-tab>
    </b-tabs>
    <print-options ref="printOpt"></print-options>
    <contract ref="contract"></contract>
    <DeliveryModal 
        ref="delRef" 
        :cycles="cycles" 
        :modalTitle="modalTitle" 
        @setIar="onCreateIAR($event)"
    />
    <transition name="fade">
      <div @mouseenter="mouseOverSearch = true" @mouseleave="mouseOverSearch = false" class="position-fixed"
        style="bottom: 20px; left: 50px">
        <div title="Search PO" class="avatar-sm mx-auto cursor-pointer" @click="searchPo">
          <span class="avatar-title rounded-circle bg-info">
            <i class="mdi mdi-magnify font-size-24" :class="{
              'bx-tada': mouseOverSearch == true
            }"></i>
          </span>
        </div>
      </div>
    </transition>
    <PoSearch ref="PoSearch"></PoSearch>
    <PoItemUpdate ref="poItemUpdate" :modalTitle="modalTitle" @update-item="updateItem" />
    <attachment-modal
        :wActions="true"
        title="Purchase Order Attachments"
        ref="attachmentModal"
    ></attachment-modal>
    <TransferCampusModal ref="transferCampusModal" :modalTitle="modalTitle" @transfer="onTransfer" />
  </Layout>
</template>
<style>
.hide-disable {
  opacity: 1 !important;
}

.p-0 .popover-body {
  padding: 0 !important;
}

.paginate {
  z-index: -1 !important;
}

.tooltip {
  opacity: 1 !important;
}

.my-actions {
  padding: 10px 10px 0 10px;
  font-size: 12px;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.left-gap {
  margin-left: auto;
}

.v-enter-active {
  animation: fade-in 0.3s;
}

.v-leave-active {
  animation: fade-in 0.3s reverse;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
